module.exports = __webpack_public_path__ + "static/media/card_hand.543fb22f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/card_hand.svg
// module id = 186
// module chunks = 0